import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from 'app/src/queries/withCount';

import {
  ACH_BATCH_FIELDS
} from 'app/src/components/Accounting/AchBatches/queries';

const ERRORS = `errors { path, message }`;

export const SALE_FIELDS = `
  id
  name
  saleOn
  preBidOpenAt
  startAt
  endAt
  status
  bidding
  biddingNotice
  recurringSale { id, name }
  bidGroupChoiceId
  bidGroupBuyerId
  biddingFlash
  biddingFlashBackgroundColor
  biddingFlashForegroundColor
  biddingFlashFades
  biddingFlashType
  preBidSchedule { id }
  saleType
  initialTime
  retriggerTime
  addTime
`;

const SALE_VARIABLES = `
  $name: String!
  $saleOn: ISO8601Date
  $preBidOpenAt: ISO8601DateTime
  $startAt: ISO8601DateTime!
  $endAt: ISO8601DateTime
  $status: String
  $preBidScheduleId: ID!
  $saleType: String!
  $initialTime: Int
  $retriggerTime: Int
  $addTime: Int
`;

const SALE_ARGUMENTS = `
  name: $name
  saleOn: $saleOn
  preBidOpenAt: $preBidOpenAt
  startAt: $startAt
  endAt: $endAt
  status: $status
  preBidScheduleId: $preBidScheduleId
  saleType: $saleType
  initialTime: $initialTime
  retriggerTime: $retriggerTime
  addTime: $addTime
`;

export const SALE_FIELDS_AND_ERRORS = `
  sale {
    ${SALE_FIELDS}
  }
  ${ERRORS}
`;

export const SALES_WITH_COUNT = gql`
  query (
    ${WITH_COUNT_VARIABLES}
  ) {
    salesWithCount(
      ${WITH_COUNT_ARGUMENTS}
    ) {
      entries {
        ${SALE_FIELDS}
        visibleSaleAssetsCount
      }
      count
    }
  }
`;

export const CREATE_SALE = gql`
  mutation CreateSale(
    ${SALE_VARIABLES}
    $copyBuyerPaddles: Boolean,
    $copyBuyerPaddlesSaleId: ID
  ) {
    createSale(
      ${SALE_ARGUMENTS}
      copyBuyerPaddles: $copyBuyerPaddles
      copyBuyerPaddlesSaleId: $copyBuyerPaddlesSaleId
    ) {
      ${SALE_FIELDS_AND_ERRORS}
    }
  }
`;

export const UPDATE_SALE = gql`
  mutation UpdateSale(
    $id: ID!
    ${SALE_VARIABLES}
    $copyBuyerPaddles: Boolean,
    $copyBuyerPaddlesSaleId: ID
  ) {
    updateSale(
      id: $id
      ${SALE_ARGUMENTS}
      copyBuyerPaddles: $copyBuyerPaddles
      copyBuyerPaddlesSaleId: $copyBuyerPaddlesSaleId
    ) {
      ${SALE_FIELDS_AND_ERRORS}
    }
  }
`;

export const SALE = gql`
  query SALE($id: ID!) {
    sale(id: $id) {
      ${SALE_FIELDS}
      saleAssets { id }
    }
  }
`;

export const HIDE_SALE = gql`
  mutation HideSale($id: ID!) {
    hideSale(id: $id) {
      sale {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;

export const PROXIBID_EXPORT = gql`
  mutation ProxibidExport (
    $saleId: ID!
    $includeImages: Boolean
    $allAssets: Boolean
    $updateAssets: Boolean
  ) {
    proxibidExport(
      saleId: $saleId
      includeImages: $includeImages
      allAssets: $allAssets
      updateAssets: $updateAssets
    ) {
      csv
    }
  }
`;

export const ACTIVE_ACH_BATCH = gql`
  ${ACH_BATCH_FIELDS}
  query activeAchBatch {
    achBatch: activeAchBatch {
      ...AchBatchFields
    }
  }
`;

export const REMOVE_FROM_ACTIVE_BATCH = gql`
  mutation RemoveFromActiveBatch($txnId: ID!) {
    removeFromActiveBatch(txnId: $txnId) {
      txn {
        id
      }
    }
  }
`;

export const FINALIZE_ACH_BATCH = gql`
  mutation FinalizeBatch {
    finalizeBatch {
      achBatch {
        id
      }
    }
  }
`;
